<template lang='pug'>
router-link(to="/" :class="theme" v-if="currentPath === '/gallery' || currentPath === '/floor-plan'" class="logo-link cursor__link")
  picture
    IconDark
div(to="/" :class="theme" v-else-if="currentPath === '/'" class="logo-link cursor__link")
  picture
    IconLight
router-link(to="/" :class="theme" v-else class="logo-link cursor__link")
  picture
    IconLight
</template>

<script>
import IconLight from './logo-light.svg';
import IconDark from './logo.svg';
export default {
  components: {
    IconLight,
    IconDark
  },
  props: ["theme"],
  name: "LogoAW",
  data() {
    return {
      currentPath: null
    };
  },
  created() {
    this.currentPath = this.$router.history.current.path
  }
};

</script>

<style lang="sass" scoped>
.logo-link
  display: flex
  align-items: center
  justify-self: center
</style>
